<template>
  <section class="contact-section">
    <div class="section-container">
      <div class="section-header">
        <span class="section-label">Contact</span>
        <h2 class="section-title">Discutons de votre projet</h2>
        <p class="section-subtitle">
          Si vous avez des questions ou souhaitez en savoir plus sur nos services, 
          n'hésitez pas à nous contacter.
        </p>
      </div>

      <div class="contact-grid">
        <div class="contact-info">
          <div class="contact-item" v-for="(item, index) in contactItems" :key="index">
            <div class="contact-icon" v-html="item.icon"></div>
            <div>
              <h4>{{ item.title }}</h4>
              <p v-html="item.content"></p>
            </div>
          </div>
        </div>

        <div class="contact-form">
          <form @submit.prevent="handleSubmit">
            <div class="form-row">
              <div class="form-group">
                <label for="name">Nom complet *</label>
                <input 
                  type="text" 
                  id="name" 
                  v-model="form.name" 
                  required 
                  placeholder="Votre nom"
                >
              </div>
              <div class="form-group">
                <label for="phone">Téléphone *</label>
                <input 
                  type="tel" 
                  id="phone" 
                  v-model="form.phone" 
                  required 
                  placeholder="+237 6XX XXX XXX"
                >
              </div>
            </div>
            <div class="form-group">
              <label for="email">Email *</label>
              <input 
                type="email" 
                id="email" 
                v-model="form.email" 
                required 
                placeholder="votre@email.com"
              >
            </div>
            <div class="form-group">
              <label for="service">Service concerné</label>
              <input 
                type="text" 
                id="service" 
                v-model="form.service" 
                placeholder="Prêt personnel, Épargne, etc."
              >
            </div>
            <div class="form-group">
              <label for="message">Message *</label>
              <textarea 
                id="message" 
                v-model="form.message" 
                required 
                placeholder="Décrivez votre projet ou posez vos questions..."
              ></textarea>
            </div>
            <button type="submit" class="btn btn-primary btn-submit" :disabled="isSubmitting">
              <span v-if="isSubmitting" class="btn-loader"></span>
              <template v-else>
                Envoyer le message
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="22" y1="2" x2="11" y2="13"/>
                  <polygon points="22 2 15 22 11 13 2 9 22 2"/>
                </svg>
              </template>
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  name: 'ContactSection',
  data() {
    return {
      isSubmitting: false,
      form: {
        name: '',
        phone: '',
        email: '',
        service: '',
        message: ''
      },
      contactItems: [
        {
          title: 'Localisation',
          content: '184 TONGO, NGAOUNDÉRÉ<br>Cameroun',
          icon: '<svg viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>'
        },
        {
          title: 'Téléphone',
          content: '+237 620 298 484<br>+237 655 574 119',
          icon: '<svg viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>'
        },
        {
          title: 'Email',
          content: 'oasisfinance2@gmail.com',
          icon: '<svg viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>'
        },
        {
          title: "Horaires d'ouverture",
          content: 'Lun - Ven: 08h - 16h<br>Samedi: 09h - 13h',
          icon: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>'
        }
      ]
    }
  },
  methods: {
    async handleSubmit() {
      this.isSubmitting = true

      // Simuler un délai d'envoi
      await new Promise(resolve => setTimeout(resolve, 1000))

      this.isSubmitting = false

      // Afficher le popup de succès
      await Swal.fire({
        icon: 'success',
        title: 'Message envoyé !',
        html: `
          <p style="color: #64748b; font-size: 1rem; margin-top: 0.5rem;">
            Merci <strong>${this.form.name}</strong> pour votre message.<br>
            Notre équipe vous répondra dans les plus brefs délais.
          </p>
        `,
        confirmButtonText: 'Parfait !',
        confirmButtonColor: '#0A2C5E',
        background: '#ffffff',
        customClass: {
          popup: 'swal-popup-custom',
          title: 'swal-title-custom',
          confirmButton: 'swal-button-custom'
        },
        showClass: {
          popup: 'animate__animated animate__fadeInUp animate__faster'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutDown animate__faster'
        }
      })

      // Réinitialiser le formulaire
      this.form = {
        name: '',
        phone: '',
        email: '',
        service: '',
        message: ''
      }
    }
  }
}
</script>

<style scoped>
.contact-section {
  padding: 6rem 2rem;
  background: var(--off-white);
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  max-width: 700px;
  margin: 0 auto 4rem;
}

.section-label {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: rgba(37, 99, 235, 0.1);
  color: var(--accent-blue);
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  border-radius: 50px;
  margin-bottom: 1rem;
}

.section-title {
  font-family: var(--font-display);
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  color: var(--gray-900);
  line-height: 1.2;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.1rem;
  color: var(--gray-600);
  line-height: 1.7;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
}

.contact-info {
  padding-right: 2rem;
}

.contact-item {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}

.contact-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-blue);
  border-radius: 12px;
  flex-shrink: 0;
}

.contact-icon :deep(svg) {
  width: 24px;
  height: 24px;
  stroke: var(--white);
  stroke-width: 1.5;
  fill: none;
}

.contact-item h4 {
  font-family: var(--font-display);
  font-size: 1rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: 0.25rem;
}

.contact-item p {
  font-size: 0.95rem;
  color: var(--gray-600);
  line-height: 1.6;
}

.contact-form {
  background: var(--white);
  padding: 2.5rem;
  border-radius: 24px;
  box-shadow: var(--shadow-lg);
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--gray-700);
  margin-bottom: 0.5rem;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.875rem 1rem;
  font-family: var(--font-body);
  font-size: 0.95rem;
  border: 2px solid var(--gray-200);
  border-radius: 12px;
  transition: var(--transition-fast);
  outline: none;
  background: var(--white);
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: var(--primary-blue);
  box-shadow: 0 0 0 4px rgba(10, 44, 94, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

.btn-submit {
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-family: var(--font-body);
  font-weight: 600;
  text-decoration: none;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  transition: var(--transition-base);
  background: var(--primary-blue);
  color: var(--white);
}

.btn-submit:hover {
  background: var(--primary-blue-light);
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.btn-submit:disabled {
  opacity: 0.8;
  cursor: not-allowed;
  transform: none;
}

.btn-loader {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 1024px) {
  .contact-grid {
    grid-template-columns: 1fr;
  }

  .contact-info {
    padding-right: 0;
  }
}

@media (max-width: 768px) {
  .contact-section {
    padding: 4rem 1.5rem;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .contact-form {
    padding: 1.5rem;
  }
}
</style>